export default __webpack_public_path__ + "static/media/gallery_06.50efca15.jpg";